var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import * as PropTypes from 'prop-types';
import { DatePicker } from '@progress/kendo-react-dateinputs';
/**
 * The DateFilter component used for editing date value of FilterDescriptor object.
 */

var DateFilter = function (_super) {
  __extends(DateFilter, _super);

  function DateFilter() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.onChange = function (event) {
      _this.props.onFilterChange.call(undefined, {
        nextFilter: __assign({}, _this.props.filter, {
          value: event.value
        })
      });
    };

    return _this;
  }
  /**
   * @hidden
   */


  DateFilter.prototype.render = function () {
    var filter = this.props.filter;
    return React.createElement(DatePicker, {
      value: filter.value || null,
      onChange: this.onChange
    });
  };
  /**
   * @hidden
   */


  DateFilter.propTypes = {
    filter: PropTypes.object.isRequired,
    onFilterChange: PropTypes.func.isRequired
  };
  return DateFilter;
}(React.Component);

export { DateFilter };